import { Calendar } from "primereact/calendar";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CalendarComp = ({ options, setFilter }) => {
  const { t } = useTranslation("master");
  useEffect(() => {
    if (options.value === "" || !options.value) {
      setFilter(false);
    }
  }, [options.value, setFilter]);
  return (
    <Calendar
      value={options.value}
      onChange={(e) => {
        options.filterCallback(e.value, options.index);
        if (e.value) {
          setFilter(true);
        } else if (!e.value || e.value === "") {
          setFilter(false);
        }
      }}
      dateFormat="mm/dd/yy"
      showIcon
      placeholder={t("Search")}
      mask="99/99/9999"
    />
  );
};

CalendarComp.propTypes = {
  setFilter: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
};

export default CalendarComp;
